// Instagram/Facebook portrait post — event banner (calendar + event page).
export const EVENT_BANNER_RATIO = '4 / 5';
